var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"html-content",domProps:{"innerHTML":_vm._s(_vm.content)}}),(_vm.showPreviewViewer)?_c('div',{staticClass:"image-preview-wrap",on:{"click":_vm.closePreviewViewer}},[_c('img',{staticClass:"image-preview",attrs:{"src":_vm.imgUrl,"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }